import { render, staticRenderFns } from "./StockReductionDetails_HppTotal.vue?vue&type=template&id=64c5824e&"
import script from "./StockReductionDetails_HppTotal.vue?vue&type=script&lang=js&"
export * from "./StockReductionDetails_HppTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports